import React, {useEffect, useState} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import {connect} from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import {goToPage, reportDWH} from '../saleJetBlockSlice';
import {createSaleAsync, emailIsExist} from '../saleBlockAsyncThunk';
import Summary from '../Partials/Summary/Summary';
import {gtag4} from '../../../../utilities/analytics/tracking';

const SummaryPage = (props) => {
  const [isConfirmTerms, setIsConfirmTerms] = useState(false);
  const [confirmTermsErrorText, setConfirmTermsErrorText] = useState('');

  useEffect(() => {
    props.reportDWH({actionType: 'Summary Page', status: 'Ongoing', messageText: 'Summary Page Displayed'});
    let cellularStep = props.flowType == 'existsCustomer' ? '13' : '12';
    gtag4({
      event: props.saleType == 'cellular' ? `cellular_Step${cellularStep}_SummaryPage` : `${props.saleType}_Step9_SummaryPage`,
      step: props.saleType == 'cellular' ? cellularStep : '9',
      action: 'SummaryPage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
    });
  }, []);

  //page params
  let isDisplayFooter = true;
  let title = props.saleType == 'cellular' ? 'בואו נאשר ונתקדם' : 'אישור פרטי ההזמנה';
  let subTitle = props.saleType == 'cellular' ? '' : 'האם כל הפרטים נכונים?';
  let btnText = props.flowType == 'newCustomer' ? 'אישור ומעבר לתשלום' : 'אישור';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      {/* <h1 className='sale-title'></h1> */}
      <h1 className='sale-title-big'>{title}</h1>
      <h2 className='sale-title-small'>{subTitle} </h2>
    </div>
  );

  let currentPageView = (
    <Summary
      generalTermsAgreementLink={props.generalTermsAgreementLink}
      connectionAgreementLink={props.connectionAgreementLink}
      programDetailsLink={props.programDetailsLink}
      summaryDetails={props.summaryDetails}
      isConfirmTerms={isConfirmTerms}
      confirmTermsErrorText={confirmTermsErrorText}
      onClickConfirmTerms={handleOnClickConfirmTerms}
    />
  );

  return (
    <div className='slideAnimation summary-page'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );

  function handleOnClickConfirmTerms() {
    console.debug('[terms-checkbox] setIsConfirmTerms', isConfirmTerms);
    setIsConfirmTerms(!isConfirmTerms);
  }

  function handlePageContinue() {
    if (!isConfirmTerms) {
      setConfirmTermsErrorText('אנא אשרו את תנאי ההסכם');
    } else {
      props.reportDWH({actionType: 'Summary Page', status: 'Ongoing', messageText: 'Summery Page Button Clicked'});
      if (props.flowType == 'newCustomer') {
        props.goToPage('paymentPage');
      } else {
        props.goToPage('createSaleInProcess');
      }
      let cellularStep = props.flowType == 'existsCustomer' ? '13' : '12';
      gtag4({
        event:
          props.saleType == 'cellular'
            ? `cellular_Step${cellularStep}_SummaryContinueButton`
            : `${props.saleType}_Step9_SummaryContinueButton`,
        step: props.saleType == 'cellular' ? cellularStep : '9',
        button: btnText,
        action: 'SummaryContinueButton',
        funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
      });
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    summaryDetails: state.saleJetBlock.summaryDetails,
    programDetailsLink: state.saleJetBlock.selectedPackage.programDetailsLink,
    connectionAgreementLink: state.saleJetBlock.selectedPackage.connectionAgreementLink,
    generalTermsAgreementLink: state.saleJetBlock.saleBlockData.generalTermsAgreementLink,
    //email: state.saleJetBlock.personalInfo.email,
    //errorText: state.saleJetBlock.errorText
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPage);
